import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLoads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.425,
    height: 28.714,
    viewBox: "0 0 27.425 28.714"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.957 16.661v8.779l8.468-4.906v-8.849z",
    fill: "#ffd164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.967 16.661v8.779l-8.038-4.644v-8.849z",
    fill: "#f6b243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.929 11.944l8.038 4.714 8.458-4.976-8.056-4.689z",
    fill: "#ffe17d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.55 14.587v2.352l1.913-1.093v-2.425z",
    fill: "#e6646e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.521 9.873l8.038 4.714 1.9-1.163-8.056-4.689z",
    fill: "#ff8087"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.468 19.934v8.779L0 23.807v-8.849z",
    fill: "#f6b243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.458 19.935v8.779l8.038-4.644v-8.849z",
    fill: "#ffd164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.497 15.22l-8.038 4.714-8.458-4.976 8.056-4.689z",
    fill: "#ffe17d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.876 17.86v2.355l-1.913-1.093v-2.425z",
    fill: "#e6646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.904 13.147l-8.038 4.714-1.9-1.163 8.056-4.689z",
    fill: "#ff8087"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.46 8.153v7.406l-7.143-4.138V3.956z",
    fill: "#f6b243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.452 8.154v7.406l6.781-3.918V4.177z",
    fill: "#ffd164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.232 4.176l-6.781 3.977-7.135-4.2 6.8-3.956z",
    fill: "#ffe17d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.429 6.404v1.987l-1.614-.922V5.423z",
    fill: "#e6646e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.202 2.427L9.421 6.404l-1.605-.981 6.8-3.956z",
    fill: "#ff8087"
  }))));
}

export { SvgLoads as ReactComponent };
//# sourceMappingURL=Loads.svg.js.map
